<template>
  <div>
    <p v-if="!pdfObjList" class="button is-loading is-text is-large is-fullwidth" style="font-size: 3em;"></p>
    <p style="margin-top: 12px; margin-bottom: 0px;" v-if="pdfObjList && !pdfObjList.length && instrumentState.online" class="notification is-info is-right">

      <span class="icon" >
        <i class="fas fa-info-circle"></i>
      </span> Nenhum certificado disponível. O certificado pode estar em processo de revisão e estará disponível em breve. Neste caso, os resultados já podem ser acessados no módulo ANÁLISE.
    </p>

    <div v-if="erro === 'unauthorized' || !remoteDB || !instrumentState.online">
      <div class="" style="margin-top: 12px;">
        <span class="icon has-text-warning">
          <i class="fas fa-exclamation-triangle"></i>
        </span>
        <span v-if="!instrumentState.online" class="title is-6">Certificado disponível apenas online.</span>
        
        <span v-if="instrumentState.online" class="title is-6">
          Sua sessão expirou. É necessário realizar o login novamente para visualizar os certificados.
        </span>
        <div>
          <br>
          <a class="button is-link" @click="setLoggedOut">Fazer o Login</a>
          
        </div>

      </div>
    </div>

    <nav class="level is-mobile" style="padding-top: 20px;">
      <!-- Left side -->
      <div class="level-left">
        <div class="level-item">
          <div v-if="pdfObjList && pdfObjList.length">
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <label class="label">Documento</label>
                  <div class="control">
                    <div class="select" v-bind:class="loading ? 'is-loading' : ''">
                      <select v-model="src" class="certificadoList">
                        <option
                          v-for="item in pdfObjList"
                          :value="item.path">{{item.name}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right side -->
      <div class="level-right" style="padding-top: 17px;padding-right: 6px;">
        <div class="level-item" v-if="remoteDB && instrumentState.online && instrumentState.usuarioTemAdminRole && instrumentState.usuarioGerencia && pdfList">
          <div class="field has-addons">
            <p class="control">
              <div class="file">
                <label class="file-label">
                  <input ref="uploadInput" class="file-input" type="file" name="resume" accept=".pdf" multiple />
                  <span class="file-cta" style="border-radius: 0;">
                    &nbsp;&nbsp;<span class="file-icon">
                      <i class="fas fa-upload"></i>
                    </span>
                    <span class="file-label">                        
                    </span><span class="is-hidden-mobile">Enviar documento</span>
                  </span>
                </label>
              </div>
            </p>
            <p class="control" v-if="pdfList && pdfList.length !== 0">
              <a class="button is-danger" @click="instrumentState.modals.confirmarRemoverCertificado = true">
                &nbsp;&nbsp;<span class="icon">
                  <i class="fas fa-times"></i>
                </span><span class="is-hidden-mobile">Remover</span>
              </a>
            </p>
          </div>


        </div>

      </div>
    </nav>

    <p v-if="instTipo !== 'instrumentoCliente' && temAnaliseSemCertificado" style="margin-top: 4px;" class="is-info">O certificado mais recente está em revisão. Uma prévia dos resultados já pode ser conferida no módulo <router-link :to="{ path: `/instrumento/${instId}/analise`}">ANÁLISE</router-link>.
    </p>

    <!-- #Remover Certificado -->
    <div class="modal modal-fx-fadeInScale" v-bind:class="instrumentState.modals.confirmarRemoverCertificado ? 'is-active' : ''">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <h6 class="title is-6">Atenção</h6>

          <p class="field">
            O documento selecionado será removido. Tem certeza?
          </p>

          <div class="field is-grouped">
            <p class="control">
              <a class="button is-small" @click="instrumentState.modals.confirmarRemoverCertificado = false">
                Cancelar
              </a>
            </p>
            <p class="control">
              <a class="button is-small is-link" :class="" @click="removeAnexo">
                Confirmar
              </a>
            </p>
          </div>

        </div>
      </div>
    </div>
    <!-- /Remover Certificado -->

    
  </div>
  
</template>

<script>

import PDFObject from 'pdfobject'
import {fnSetLoggedOut} from '../fn'


export default {
  props: [],
  watch: {
    'instrumentState.online': function (val) {
      if (val) {
        this.erro = null
        this.pegaLista()
        this.embedPdf()
      }
    },
    'src' () {
      this.embedPdf()
    },
    'okParaGerenciarDocumentos': function (val) {
    }
  },
  created () {
    this.pegaLista()
  },
  data () {
    return {
      instrumentState: INSTRUMENT_STORE.state,
      erro: false,
      pdfObjList: null,
      pdfList: null,
      src: null,
      loading: false,
      remoteDB: INSTRUMENT_STORE.remoteDB,
      attachmentDocRev: undefined
    }
  },
  mounted () {
    var el = document.getElementById('pdf-container')
    el.style.display = 'none'
    this.embedPdf()
  },
  methods: {
    habilidaGestaoDocumentos () {
      // Habilita ao usuário a possibilidade de inserir documentos
      var inputFile = this.$refs.uploadInput
      if (!inputFile) return
      inputFile.addEventListener('change', () => {
        if (!this.$refs.uploadInput.value || this.$refs.uploadInput.value === '') return
        var attachmentFileName = this.$route.params.id+'_anexos'
        
        var doc = {
          "_id": attachmentFileName,
          "type": "anexos",
          "_attachments": {
          }
        };
        
        this.remoteDB.get(attachmentFileName).then((attachmentDoc) => {
          doc = attachmentDoc
        }).catch((err) => {
          console.log(err)
          if (err.error !== 'not_found') {
            doc = null
          }
        }).then(() => {
          if (!doc) return
          for (var i = 0; i < inputFile.files.length; i++) {
            var file = inputFile.files[i]
            if (file.type !== 'application/pdf') {
              this.$toasted.show('O arquivo enviado deve ser um documento PDF.', {icon: 'fa-exclamation-triangle'} )
            } else {
              doc._attachments = doc._attachments || {}
              doc._attachments[file.name] = {
                'content_type': file.type,
                'data': file
              }
            }
          }
          return this.remoteDB.put(doc).then((result) => {
            this.pegaLista()
            this.$refs.uploadInput.value = ''
          })        
        })

      }, false);

    },
    removeAnexo () {
      var attName = this.src.split('/')[this.src.split('/').length -1]
      
      this.remoteDB.removeAttachment(this.$route.params.id+'_anexos', attName, this.attachmentDocRev).then((result) => {
        this.src = null
        this.pegaLista()
        this.instrumentState.modals.confirmarRemoverCertificado = false
      }).catch((err) => {
        this.$toasted.show('Não foi possível remover o documento.', {icon: 'fa-exclamation-triangle'})
        console.log(err)
      })

    },
    pegaLista () {
      var remoteDB = INSTRUMENT_STORE.remoteDB
      
      if (!remoteDB) return

      remoteDB.get(this.$route.params.id+'_anexos')
      .then((doc) => {
        var anexos = doc['_attachments']
        this.attachmentDocRev = doc._rev
        var nomedb = localStorage.getItem('nomedb')
        
        let pdfObjList = _.keys(anexos)
        pdfObjList = _.filter(pdfObjList, (item) => {
          return anexos[item]
            .content_type === 'application/pdf'
          ;
        }).map( (item) => {
          return {
            path: window.DB_ADDR+nomedb+'/'+this.$route.params.id+'_anexos/'+item,
            name: item
          }
        })
        pdfObjList = _.sortBy(pdfObjList, (item) => {
          // numeroCert espera que o nome do arquivo tenha o formato padrao 
          // de numeracao de certificados do IPT.
          var numeroCert = parseInt(item.name.split('-')[0])
          // Se nao tiver o formato esperado, retorna o nome sem tentar converter
          if (isNaN(numeroCert)) {
            return item.name
          } else {
            return numeroCert
          }
        })
        pdfObjList = _.reverse(pdfObjList)
        ;
        this.pdfObjList = pdfObjList

        this.pdfList = this.pdfObjList.map((item) => item['path'])
        if (!this.pdfList || this.pdfList.length === 0) {
          var el = document.getElementById('pdf-container')
          el.style.display = 'none'
        }
        if (!this.src) {
          this.src = this.pdfList[0] || null
        }

      }).catch( (err) => {
        this.erro = err.error
        if (err.name === 'unknown') {
        } else {
          // Nada encontrado
          console.log(err)
          this.pdfObjList = true
          this.pdfList = []
        }
      }).finally( () => {
        this.habilidaGestaoDocumentos()
      })
    },
    setLoggedOut () {
      fnSetLoggedOut()
    },
    embedPdf () {

      var options = {
        pdfOpenParams: {
          scrollbar: '0',
          toolbar: '0',
          statusbar: '0',
          messages: '0',
          navpanes: '0'
        },
        id: 'pdfjs-iframe-id',
        PDFJS_URL: 'https://pdf.procal.ipt.br/pdfjs/web/viewer.html',
        forcePDFJS: typeof window.orientation !== 'undefined' // Forca usar pdfjs hospedado para mobile
        //forcePDFJS: (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) && (navigator.userAgent.toLowerCase().indexOf('mobile') > -1) // Forca usar pdfjs hospedado para o firefox
        //PDFJS_URL: 'https://arturaugusto.github.io/pdfview/web/viewer.html'
      }

      if (!this.src) return
      this.loading = true
      var remoteDB = INSTRUMENT_STORE.remoteDB
      remoteDB.get(this.$route.params.id+'_anexos')
      .then((doc) => {
        //console.log(this.src)
        PDFObject.embed(this.src, '#pdf-container', options)
        var el = document.getElementById('pdf-container')
        el.style.display = ''
        fnHandleResize()
        
        /*
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
          var iframe = document.getElementById('pdfjs-iframe-id')
          console.log(iframe.contentWindow.location.href, iframe.src)
          iframe.src = this.src
          iframe.onload = () => {
            this.loading = false
          }
        } else {
          window.setTimeout(() => {
            this.loading = false
          }, 4000)
        }
        */
        
        window.setTimeout(() => {
          this.loading = false
        }, 4000)

      })
      .catch((e) => {
        console.log('erro ao carregar certificado')
        console.log(e)
        this.loading = false
      })
    }
  },
  computed: {
    instId () {
      if (this.$route.params) {
        return this.$route.params.id
      }
      return undefined
    },
    instTipo () {
      return INSTRUMENT_STORE.state.data.inst.type
    },
    temAnaliseSemCertificado () {
      if (!this.instId) return
      if (this.$route.path.split('/')[3] !== 'certificado' && this.$route.path.split('/')[3] !== undefined) return
      if (!this.instrumentState.data.seriesDenormRes.length || !this.pdfObjList || !this.pdfObjList.length) return
      var certAnalise = this.instrumentState.data.seriesDenormRes[0].Certificado
      // Nao emite alerta se nao for certificado IPT
      if (certAnalise.indexOf('-101') === -1) return
      var certificados = this.pdfObjList.map((item) => item.name.split('.pdf')[0])

      // Nao aplica regra pra o usuario procaldemo
      if (certificados[0].indexOf('DEMO') !== -1) return false
      
      var res = certAnalise.split('/')
        .reduce((acc, curr) => acc || certificados.indexOf(curr) === -1, false)
      ;
      return res
    },
    okParaGerenciarDocumentos () {
      return !!(this.remoteDB &&
             this.instrumentState.online &&
             this.instrumentState.usuarioTemAdminRole &&
             this.instrumentState.usuarioGerencia && !this.erro && this.pdfList)
    }
  }
}
</script>

<style scoped>
</style>
